export default function randomId(prefix?: string): string {
  const p = prefix ? `${prefix}-` : '';
  return `${p}${Date.now().toString(36) + Math.random().toString(36).substr(2)}`;
}
